<template>
  <div class="content">
    <DataReportSelect selectTabsType="areaData" @event-filter="fetchData">
      <span slot="areaData">
        <div class="charts-warp">
          <div class="charts-container">
            <!-- <el-row> -->
            <ContentBox>
              <template slot="title">
                <div>
                  <span class="title">地域分布图</span>
                  <el-radio-group class="map-box-btns" v-model="fieldType" @change="getRegionData">
                    <el-radio-button :label="1">曝光</el-radio-button>
                    <el-radio-button :label="2">点击</el-radio-button>
                  </el-radio-group>
                </div>
              </template>
              <div v-if="regionOption.series[0].data.length" class="chart-area">
                <div>
                  <Echarts elId="ChinaMap" :option="regionOption" height="400px" width="50%"></Echarts>
                </div>
                <VeBar ref="bar" :data="barData" :loading="loading" :extend="barExtend"></VeBar>
              </div>
              <div v-else class="no-message">
                <ChartDataEmpty />
              </div>
            </ContentBox>
            <ContentBox>
              <div class="download" slot="title">
                <p class="title">详细数据</p>
                <p class="title-right">
                  <el-button size="mini"  style="display: flex; justify-items: center; align-items: center" :loading="loadingExport" @click="fetchData('export')">
                    <i class="el-icon-cc-unorderedlist" style="font-size: 12px;padding-right:4px"></i>导出
                  </el-button>
                </p>
              </div>
              <Table :props="table.props" :header="tableHeader" :data="table.data" />
              <pagination
                v-bind:currentpage="currentPage"
                v-bind:pagesize="pageSize"
                v-bind:totalcount="totalCount"
                @handle-size-change="handleSizeChange"
                @handle-current-change="handleCurrentChange"
              ></pagination>
            </ContentBox>
            <!-- </el-row> -->
          </div>
        </div>
      </span>
    </DataReportSelect>
  </div>
</template>
<script>
// import vcharts from '@/components/echarts'
import DataReportSelect from '@/components/DataReportSelect'
import ChartDataEmpty from '@/components/ChartDataEmpty'
// import VeMap from 'v-charts/lib/map.common'
import VeBar from 'v-charts/lib/bar.common'
import 'echarts/lib/component/legendScroll'
import 'echarts/lib/component/visualMap'
import 'v-charts/lib/style.css'
import Echarts from '@/components/charts/Echarts.vue'
import downLoad from '@/utils/downLoad';

export default {
  inject: ['searchData'],
  components: {
    // vcharts,
    DataReportSelect,
    // VeMap,
    VeBar,
    Echarts,
    ChartDataEmpty
  },
  data() {
    this.barExtend = {
      legend: {
        show: false
      },
      tooltip: {
        confine: true
      },
      grid: {
        top: '2%',
        bottom: -10,
        right: 30,
        left: -30,
        containLabel: true
      },
      series: {
        roam: false,
        visualMap: false,
        zlevel: 2,
        barMaxWidth: 8,
        barGap: 0
      },
      yAxis: {
        type: 'category',
        inverse: true,
        nameGap: 16,
        axisLine: {
          show: false,
          lineStyle: {
            color: '#333'
          }
        },
        axisTick: {
          show: false,
          lineStyle: {
            color: '#ddd'
          }
        },
        axisLabel: {
          interval: 0,
          color: '#666',
          align: 'left',
          margin: 90,
          fontSize: 13,
          rich: {
            idx0: {
              color: '#ffffff',
              backgroundColor: '#FF8B00',
              borderRadius: 20,
              // padding: [10, 18]
              width: 20,
              height: 20,
              align: 'center'
            },
            idx1: {
              color: '#ffffff',
              backgroundColor: '#FF8B00',
              borderRadius: 20,
              width: 20,
              height: 20,
              align: 'center'
            },
            idx2: {
              color: '#ffffff',
              backgroundColor: '#FF8B00',
              borderRadius: 20,
              width: 20,
              height: 20,
              align: 'center'
            },
            idx: {
              color: 'rgba(0,0,0,0.65)',
              backgroundColor: '#F0F2F5',
              borderRadius: 20,
              width: 20,
              height: 20,
              align: 'center'
            },
            title: {
              width: 80
            }
          },
          formatter: function (value, index) {
            if (index < 3) {
              return '{idx' + index + '|' + (1 + index) + '} {title|' + value + '}'
            } else {
              return '{idx|' + (1 + index) + '} {title|' + value + '}'
            }
          }
        }
      },
      xAxis: {
        show: false,
        splitLine: {
          // 坐标轴在 grid 区域中的分隔线。
          show: false
        }
      }
    }
    return {
      fieldType: 1,
      isShowSelect: false,
      isShowTimePicker: true,
      activeName: 'audienceCharts',
      // 分页
      pageSize: 10,
      currentPage: 1,
      totalCount: 1,
      regionData: [],
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            label: '日期',
            align: 'left',
            prop: 'statData',
            'show-overflow-tooltip': true
          },
          {
            label: '省份',
            align: 'left',
            prop: 'provinceName',
            'show-overflow-tooltip': true
          },
          {
            label: '城市',
            align: 'left',
            prop: 'cityName',
            'show-overflow-tooltip': true
          },
          {
            label: '计划名称',
            align: 'left',
            prop: 'scheduleName',
            isShow: true,
            width: 200,
            'show-overflow-tooltip': true
          },
          {
            label: '广告位',
            align: 'left',
            prop: 'spaceName',
            'show-overflow-tooltip': true
          },
          {
            label: '素材名称',
            align: 'left',
            prop: 'mediaName',
            'show-overflow-tooltip': true
          },
          {
            label: '曝光量(PV)',
            align: 'right',
            prop: 'pv',
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.pv || 0).toLocaleString()
            }
          },
          {
            label: '点击量(CV)',
            align: 'right',
            prop: 'clickPv',
            'show-overflow-tooltip': true,
            formatter: (params) => {
              return (params.cv || 0).toLocaleString()
            }
          }
        ],
        data: []
      },
      barData: {
        columns: ['位置', 'pv'],
        rows: []
      },
      regionOption: {
        tooltip: {
          triggerOn: 'mousemove',
          formatter: function (e, t, n) {
            if (isNaN(e.value)) {
              return
            }
            return e.seriesName + '<br />' + e.name + ':' + e.value
          }
        },
        visualMap: {
          min: 0,
          max: 100,
          show: false
        },
        geo: {
          map: 'china',
          center: [108, 35],
          roam: !1,
          scaleLimit: {
            min: 1,
            max: 2
          },
          zoom: 1.1,
          label: {
            normal: {
              show: !0,
              fontSize: '12',
              color: 'rgba(0,0,0,0.7)'
            }
          },
          itemStyle: {
            normal: {
              borderColor: 'rgba(0, 0, 0, 0.5)'
            },
            emphasis: {
              areaColor: '#f2d5ad',
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              borderWidth: 0
            }
          }
        },
        series: [{
          name: '曝光量',
          type: 'map',
          geoIndex: 0,
          data: []
        }]
      },
      loading: false,
      loadingExport: false
      // screenWidth: document.documentElement.clientWidth,
      // sortHeight: 76
    }
  },
  computed: {
    tableHeader() {
      let header = []
      if (this.searchData.model.scheduleId && this.searchData.model.mediaId) {
        header = this.table.header.filter((item) => item.prop !== 'scheduleName')
      } else if (this.searchData.model.scheduleId && !this.searchData.model.mediaId) {
        header = this.table.header.filter((item) => item.prop !== 'mediaName')
      } else {
        header = this.table.header.filter(
          (item) => item.prop !== 'scheduleName' && item.prop !== 'mediaName'
        )
      }
      return header
    }
  },
  methods: {
    handleExport() {
      this.loading = false
      let form = JSON.parse(JSON.stringify(this.searchData.model))
      form.beginDate = this.$moment(this.searchData.time[0]).format('YYYY-MM-DD')
      form.endDate = this.$moment(this.searchData.time[1]).format('YYYY-MM-DD')
      form.pageSize = 20000
      form.pageNo = 1
      this.loadingExport = true
      const options = {
        url: 'api/dsp/report/exportRegionExcel',
        data: form
      }
      downLoad(options)
        .then(res => {
          this.loadingExport = false
        })
        .catch(() => {
          this.loadingExport = false
        })
    },
    // 每页显示数据量变更, 如每页显示10条变成每页显示20时,val=20
    handleSizeChange: function (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getTableData()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange: function (val) {
      this.currentPage = val
      this.getTableData()
    },
    fetchData(type) {
      if (this.searchData.model.orderId) {
        this.loading = true
        let form = JSON.parse(JSON.stringify(this.searchData.model))
        form.beginDate = this.$moment(this.searchData.time[0]).format('YYYY-MM-DD')
        form.endDate = this.$moment(this.searchData.time[1]).format('YYYY-MM-DD')
        if (type === 'export') {
          this.handleExport()
          return
        }
        this.$service.getAreaReport(form).then((data) => {
          this.regionData = data.regionList
          this.getRegionData()
        })
        this.pageSize = 10
        this.currentPage = 1
        this.getTableData()
        setTimeout(() => {
          this.loading = false
        }, 300)
      }
    },
    getRegionData() {
      let rows = []
      let barRows = []
      this.regionData.forEach((item) => {
        let provinceName = item.provinceName.replace('省', '').replace('市', '')
        const count = this.fieldType === 1 ? item.pv : item.clickPv
        provinceName = provinceName.length > 3 ? provinceName.slice(0, 2) : provinceName
        if (provinceName === '内蒙') {
          provinceName = '内蒙古'
        }
        rows.push({
          name: provinceName,
          value: count
        })
        barRows.push({
          位置: provinceName,
          pv: parseInt(count)
        })
      })
      this.regionOption.series[0].data = rows
      this.barData.rows =
        barRows.length > 20
          ? barRows.splice(0, 20).sort((a, b) => b.pv - a.pv)
          : barRows.sort((a, b) => b.pv - a.pv)
    },
    getTableData() {
      let form = JSON.parse(JSON.stringify(this.searchData.model))
      form.beginDate = this.$moment(this.searchData.time[0]).format('YYYY-MM-DD')
      form.endDate = this.$moment(this.searchData.time[1]).format('YYYY-MM-DD')
      form.pageSize = this.pageSize
      form.pageNo = this.currentPage
      this.$service.getRegionPageList(form).then((data) => {
        this.table.data = data.rows || []
        const totalCount = Number(data.total)
        this.totalCount = isNaN(totalCount) ? 0 : totalCount
      })
    }
  },
  created() {
    if (this.searchData.isFilter) {
      this.fetchData()
    }
  }
}
</script>
<style lang="stylus" scoped>
.content
  position relative
.header-serach
  position relative
.charts-warp
  display flex
  flex 1
.charts-container
  width 100%
  height 100%
  margin 0 16px
p
  margin 0px
.title
  font-size 16px
  font-weight 500
.chart-area
  display flex
  flex-direction row
.chart-area > div
  width 50% !important
.no-message
  text-align center
  height 300px
.chart-title, .download
  width 100%
  display flex
  justify-content space-between
  padding-right 20px
  align-items center
.title
  font-size 16px
  font-weight 500
.map-box-btns
  margin-left 40px
  line-height 54px
</style>
